import React, { useEffect, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Loader from "../../shared/Loader/Loader";
import SubSkillCard from "../../shared/SubSkillCard/SubSkillCard";
import CompletionCard from "../../shared/CompletionCard/CompletionCard";
import Toaster from "../../shared/Toaster/Toaster";
import "./ProgressPage.scss";
import moment from "moment";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {
  LicenseObjectInterface,
  TestResultsDataInterface,
} from "../../../interfaces";
import TestResultCard from "../../shared/TestResultCard/TestResultCard";
import ReactGA from "react-ga";
import allActions from "../../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import ChartsComponent from "../../shared/ChartsComponent/ChartsComponent";
import { useParams } from "react-router-dom";
import { soloProducts, progressPageIds, productList } from "../../../globalConstants";
import { getUserNextAssessmentLevel } from "../../../utils/levelMapping";
import NoDataFound from "../../shared/NoDataFoundComponent/NoDataFound";
import { getProductName, getProductType } from "../../shared/utils/sharedUtils";
import { PRODUCT_TYPES } from "../../shared/utils/sharedConstants";
import { useElevateAssessmentDetails, useProductId, useTestProgress, useTmsCourse } from "./customHooks";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.0)",
  },
  tab: {
    "& .MuiBox-root": {
      padding: "0px",
    },
  },
}));

function TabPanel(props: any) {
  const { children, value, index, prodId, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${prodId}-${index}`}
      // aria-labelledby={`scrollable-auto-tab-${prodId}-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  prodId: PropTypes.any.isRequired,
};

function a11yProps_dynamic(index: number, prodId: any) {
  return {
    id: `scrollable-auto-tab-${prodId}-${index}`
  };
}

const ElevatePage: React.FC = () => {
  const [isProductId, setProductId] = useProductId();
  const [isTmsCourse, setTmsCourse] = useTmsCourse();
  const [isElevate, setElevate] = useElevateAssessmentDetails();
  const [isTestProgress, setTestProgress] = useTestProgress();
  const [loaderFlag, setLoaderFlag] = useState(false);
  const { paramProdID } = useParams();
  const intl = useIntl();
  const allInfo = useSelector((state: any) => state);
  const [pageInited, setPageInited] = useState(false);
  const dispatch = useDispatch();
  const [portalLoginURL, setPortalLoginURL] = useState("");
  const classes = useStyles();
  const [productTabIndex, setProductTabIndex] = useState(0);
  const [soloTab, setSoloTab] = useState(0);
  const [elevateTab, setElevateTab] = useState(0);
  const [isSoloStructuredData, setSoloStructuredData] = useState(true);
  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [activeCourse, setActiveCourse] = useState<any[]>([]);
  const [structuredElevateData, setStructuredElevateData] = useState<any[]>([]);
  const [levelsToBeRendered, setLevelsToBeRendered] = useState<any>([]);
  const [testResultsList, setTestResultsList] = useState<Array<TestResultsDataInterface> | undefined>([]);
  const [productsList, setProductsList] = useState<Array<LicenseObjectInterface> | undefined>(undefined);
  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });
  const [levelList, setlevelList] = useState<any[]>([]);
  const [levelLoaderFlag, setLevelLoaderFlag] = useState(true);

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };

  const getCurrentLevelTab = (currentCourseLevel: string) => {
    levelList.filter((course, index) => {
      if(course?.title === currentCourseLevel) {
        setSoloTab(index)
      };
      }
    );
  }

  useEffect(() => {
    if (!levelList.length && allInfo?.common?.productID) {
      let productName: string = getProductName(Number(allInfo.common.productID));
      let productType: string = getProductType(Number(allInfo.common.productID));
      if(productName && (productType === PRODUCT_TYPES.SOLO || productType === PRODUCT_TYPES.SPRINT)) {
        if(productName === "sprint_business_english" && !!sessionStorage.getItem("isDemoUser")){
          let dummyData = require("../../../data/MockData/sprintBusinessEnglishDemoLevel.json");
          setlevelList(dummyData);
        } else {
          fetch(`${process.env.REACT_APP_BLOB_STORAGE}/content/${process.env.REACT_APP_OSCAR_ENV}/product_type/${productName}/default.json`)
          .then(response => response.json())
          .then(data => {
            const levelData = data?.level;
            if (levelData) setlevelList(levelData);
          })
        }
      }
    } 
    let currentCourseLevel = allInfo.currentSoloCourseDetails.data?.Level ? 
                             allInfo.currentSoloCourseDetails.data?.Level :
                             allInfo.currentCourseDetails.data?.Level;
    let currentCourseStatus = allInfo.currentSoloCourseDetails.data?.CourseStatus ? 
                              allInfo.currentSoloCourseDetails.data?.CourseStatus :
                              allInfo.currentCourseDetails.data?.CourseStatus;
    if(levelList.length && currentCourseLevel && levelLoaderFlag){
      getCurrentLevelTab(currentCourseLevel);
      setLevelLoaderFlag(false);
    } else if(!currentCourseLevel && currentCourseStatus && levelList.length) {
      getCurrentLevelTab(levelList[0].title);
      setLevelLoaderFlag(false);
    }
  }, [levelList, allInfo.common, allInfo.currentSoloCourseDetails, allInfo.currentCourseDetails]);
 
  const handleProductChange = (event: any, newValue: any) => {
    const currentTabPid = event.currentTarget.getAttribute("data-product");
    const isProductTab = allInfo.peopleInformation.data.getpeopleInformation.license.some((product: any) => product.productId === currentTabPid);    
    setProductTabIndex(newValue);
    const pushURL: string = `${window.location.protocol}//${window.location.host}/elevate`;
    let productID: string = "";
    if (productsList && !!!productsList[newValue].productId.includes("$")) {
      productID = productsList[newValue].productId;
      if(productID) {
        window.history.pushState(null, "", `${pushURL}/${productID}`)
        productID = '';
      } else {
        window.history.pushState(null, "", `${pushURL}`)
      }
    } else {
      window.history.pushState(null, "", `${pushURL}`);
    }
    const currentCourseLevel = allInfo?.currentSoloCourseDetails?.data?.Level;
    if(levelList.length && currentCourseLevel && isProductTab && levelLoaderFlag){
      getCurrentLevelTab(currentCourseLevel);
      setLevelLoaderFlag(false);
    }
  };
  
  const shiftInitialTab = () => {
    if (parseInt(paramProdID as string) ? parseInt(paramProdID as string) : "") {
      switchTab();
    } else {
      setIsInvalidURL(true);
    }
  };

  const switchTab = () => {
    let productIndex = 0, prodIDFound = false;
    if (productsList && productsList.length > 0) {
      productsList.map((prod: any) => {
        if (prod.active) {
          let paramsProductID: any = window.location.pathname.split("/").pop();
          if (parseInt(paramsProductID as string) === parseInt(prod.productId)) {
            setProductTabIndex(productIndex);
            prodIDFound = true;
          }
          productIndex += 1;
        }
      });
      if (!prodIDFound) {
        setIsInvalidURL(true);
      }
    }
  };

  const handleElevateChange = (event: any, newValue: any) => {
    setElevateTab(newValue);
  };

  const sugarCoatNamesAndFilter = (rawLics: Array<LicenseObjectInterface>) => {
    let finalRawLicenses: any = [],
      rawLicenseArr: Array<LicenseObjectInterface> = rawLics;
    const mandatoryTabs: any = [
      {
        productId: "$0",
        productName: intl.formatMessage({ "id" : "progress_activity_report" }),
        active: 1,
      },
      {
        productId: "$1",
        productName: intl.formatMessage({ "id" : "progress_test_results" }),      
        active: 1,
      }
    ];

    let sugarCoatedPrefixes = progressPageIds.map((id: string) => {
      let productObj = productList.find((product: any) => product.productId === id);
      return {
        productId: id,
        productName: productObj ? productObj.productName : "",
      };
    });
    rawLicenseArr = [...mandatoryTabs, ...rawLicenseArr];
    sugarCoatedPrefixes = [...sugarCoatedPrefixes, ...mandatoryTabs];

    // Remove licenses based on active state
    for (let k = 0; k < rawLicenseArr.length; k++) {
      if (parseInt(rawLicenseArr[k]["active"]) === 0) {
        rawLicenseArr.splice(k, 1);
      }
    }

    for (let i = 0; i < rawLicenseArr.length; i++) {
      for (let j = 0; j < sugarCoatedPrefixes.length; j++) {
        if (rawLicenseArr[i]["productId"] === sugarCoatedPrefixes[j]["productId"]) {
          finalRawLicenses.push(rawLicenseArr[i]);
        }
      }
    }

    // sugarcoat names in licenses
    for (let i = 0; i < finalRawLicenses.length; i++) {
      for (let j = 0; j < sugarCoatedPrefixes.length; j++) {
        if (parseInt(finalRawLicenses[i]["active"]) === 1) {
          if (finalRawLicenses[i]["productId"] === sugarCoatedPrefixes[j]["productId"]) {
            finalRawLicenses[i]["productName"] = sugarCoatedPrefixes[j]["productName"];
          }
        } else {
          finalRawLicenses.splice(i, 1);
        }
      }
    }

    return finalRawLicenses;
  };

  const afterGetTestResultsAPI = () => {
    if (!!!allInfo.testProgress.isLoading) {
      if (!!!allInfo.testProgress.isFailed) {
        if (!!allInfo.testProgress.data) {
          if(!!!allInfo.testProgress.data["learnerTestResults"]){
            setTestResultsList(allInfo.testProgress.data);
          } else {
            setTestResultsList(allInfo.testProgress.data["learnerTestResults"])
          }
          // handle error page here - false
        }
      }
    }
  };

  const initGoogleAnalytics = () => {
    if (allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(84, 85) === "1") {
      const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
      ReactGA.initialize(trackingId);
      const url = window.location.pathname;
      ReactGA.set({ page: url });
      ReactGA.pageview(url);
    }
  };

  const afterGetPeopleInfo = () => {
    if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
      let licensesList: any =
        allInfo.peopleInformation &&
        allInfo.peopleInformation.data &&
        allInfo.peopleInformation.data.getpeopleInformation
          ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj }))
          : [];
      // handle error page here - false
      initGoogleAnalytics();
      setProductsList(sugarCoatNamesAndFilter(licensesList));
      generatePortalURL();
    } else {
      // handle error page here - true
    }
  };

  const getPeopleInfo = () => {
    afterGetPeopleInfo();
  };

  const generatePortalURL = () => {
    if (!!!allInfo.portalLogin.isFailed && !!allInfo.portalLogin.data) {
      let { key, signature } = JSON.parse(allInfo.portalLogin.data.getPortalLoginKey);
      let url =
        process.env["REACT_APP_PROFILE_URL"] +
        "/account/portallogin?key=" +
        key +
        "&signature=" +
        signature +
        "&virtual_step=1";
      // handle error page here - false
      setPortalLoginURL(url);
    }
  };

  const getPartTitle = (partTitle?: string) => {
    if (partTitle) {
      return (
        <div className="h5_title">
          {translate("progress_partText")} {partTitle}
        </div>
      );
    } else {
      return <div className="h5_title">--</div>;
    }
  };

  useEffect(() => {
    if (productsList && productsList.length > 0) {
      shiftInitialTab();
    }
  }, [productsList]);

  useEffect(() => {
    setPageInited(true);
    sessionStorage.removeItem("chInited");  
  }, []);

  useEffect(() => {
    if (!!!allInfo.common.isLoading && !!!allInfo.peopleInformation.isLoading && !!!allInfo.portalLogin.isLoading) {
      if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
        getPeopleInfo();
      }
    }
  }, [allInfo.common, allInfo.peopleInformation, allInfo.portalLogin]);

  // ======================= Start of Elevate progress fetch ======================
  const extractLevelValueAlone = () => {
    return levelsToBeRendered.slice().map((levelsObj: any) => levelsObj.level);
  };

  useEffect(() => {
    if (levelsToBeRendered.length > 0) {
      const availableLevels = extractLevelValueAlone();
      if (!!!allInfo.elevateAssessmentDetails.isLoading && !allInfo.elevateAssessmentDetails.data) {
        dispatch(allActions.elevateAssessmentDetailsAction.elevateAssessmentDetails("EN", availableLevels.join(",")));
      }
    }
  }, [levelsToBeRendered]);

  useEffect(() => {
    if (
      allInfo.common.productID === "25" &&
      !!!allInfo.tmsLearnerSessions.isLoading &&
      !!!allInfo.tmsLearnerSessions.data &&
      !sessionStorage.getItem("isDemoUser")
    ) {
      dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
    } else {
      if (
        allInfo.tmsLearnerSessions.data &&
        allInfo.createSessionService.data &&
        levelsToBeRendered.length > 0 &&
        activeCourse.length > 0
      ) {
        let sortedSessions = allInfo.tmsLearnerSessions.data.getTMSLearnerSessions
          .slice()
          .sort((a: any, b: any) => b.startTime - a.startTime)
          .reverse();
        let filteredSessions = sortedSessions.filter(
          (sessionObj: any) => sessionObj.status === "finished" && activeCourse[0].courseId === sessionObj.course
        );
        let statistics = allInfo.createSessionService.data.createSessionService;
        if (filteredSessions.length > 0) {
          restructureElevateData(filteredSessions, levelsToBeRendered, statistics);
        }
      }
    }

    if (
      allInfo.common.productID === "25" &&
      !!!allInfo.createSessionService.isLoading &&
      !allInfo.createSessionService.data &&
      activeCourse.length > 0 &&
      !sessionStorage.getItem("isDemoUser")
    ) {
      dispatch(allActions.createSessionServiceAction.createSessionService(activeCourse[0].courseId));
    }
  }, [
    allInfo.peopleInformation,
    allInfo.tmsLearnerSessions,
    allInfo.createSessionService,
    activeCourse,
    levelsToBeRendered,
  ]);

  const restructureElevateData = (sessions: any, levelsToBeRendered: any, sessionsStatics: any) => {
    let elevateSessionsData: any = [];
    let elevateCourseLength = Number(sessionsStatics.length) / 18;
    for (let i = 0; i <= elevateCourseLength - 1; i++) {
      let tempObj: any = {};
      tempObj["level"] = levelsToBeRendered[i].level;
      let partSessions = sessions.splice(0, 18);
      let partsObj: any = {
        coursePartTitle: levelsToBeRendered[i].part,
        level: levelsToBeRendered[i].level,
        statistics: {
          totalsessions: 18,
          sessions: partSessions.length,
        },
      };
      let sessionsCompleted: any = [];
      partSessions.forEach((session: any, index: number) => {
        let sessionObj: any = {};
        sessionObj["subskilltitle"] = `Session ${index + 1}`;
        let getTime = `${moment.unix(parseInt(session.endTime)).format("DD MMM YYYY / hh:mm A")} ${moment.unix(parseInt(session.endTime)).tz(moment.tz.guess()).format("z")}`
        sessionObj["sessioncompleteddate"] = getTime || "--";
        sessionsCompleted.push(sessionObj);
      });
      partsObj["sessionsCompleted"] = sessionsCompleted;
      if (elevateSessionsData.length > 0) {
        let foundLevelObj = elevateSessionsData.find((obj: any) => obj.level === levelsToBeRendered[i].level);
        foundLevelObj
          ? foundLevelObj.parts.push(partsObj)
          : elevateSessionsData.push({ level: levelsToBeRendered[i].level, parts: [partsObj] });
      } else {
        elevateSessionsData.push({ level: levelsToBeRendered[i].level, parts: [partsObj] });
      }
    }
    setStructuredElevateData(elevateSessionsData);
  };

  useEffect(() => {
    if (
      allInfo.getLearnerDetails.data &&
      !!!allInfo.peopleInformation.isLoading &&
      allInfo.peopleInformation.data &&
      !!allInfo.createSessionService.data &&
      !sessionStorage.getItem("isDemoUser")
    ) {
      if (allInfo.getLearnerDetails.data.getLearnerInfo) {
        let courseLevel = allInfo.getLearnerDetails.data.getLearnerInfo.CourseLevel;
        let courseLength = Number(allInfo.createSessionService.data.createSessionService.length);
        if (courseLength / 18 === 1) {
          setLevelsToBeRendered([
            {
              level: courseLevel,
              part: "A",
            },
          ]);
        } else if (courseLength / 18 === 2) {
          setLevelsToBeRendered([
            {
              level: courseLevel,
              part: "A",
            },
            {
              level: courseLevel,
              part: "B",
            },
          ]);
        } else if (courseLength / 18 === 4) {
          const nextLevel = getUserNextAssessmentLevel(courseLevel);
          setLevelsToBeRendered([
            {
              level: courseLevel,
              part: "A",
            },
            {
              level: courseLevel,
              part: "B",
            },
            {
              level: nextLevel,
              part: "A",
            },
            {
              level: nextLevel,
              part: "B",
            },
          ]);
        }
      }
      if(!!allInfo.tmsCourses.data) {
        let activeCourse = allInfo.tmsCourses.data.getTMSGetCourse.filter((courseFilter: any) => courseFilter.status === "3" || courseFilter.status === "1");
        setActiveCourse(activeCourse);
      }
    }

    if (allInfo.common.productID === "25" && !!!allInfo.getLearnerDetails.isLoading && !!!allInfo.getLearnerDetails.data && !sessionStorage.getItem("isDemoUser")) {
      dispatch(allActions.getLearnerDetailsAction.getLearnerDetails(allInfo.common.leuId, Number(allInfo.common.productID)));
    }
  }, [allInfo.peopleInformation, allInfo.getLearnerDetails, allInfo.createSessionService, allInfo.tmsCourses, allInfo.common]);
  // ====================== End ==========================

  useEffect(() => {
    if (!!!allInfo.testProgress.isLoading) {
      afterGetTestResultsAPI();
    }
  }, [allInfo.testProgress]);

  useEffect(() => {
    if (
      !!!allInfo.peopleInformation.isLoading &&
      !!!allInfo.portalLogin.isLoading &&
      !!!allInfo.skillsProgress.isLoading &&
      !!!allInfo.testProgress.isLoading &&
      !!!allInfo.reachProgress.isLoading &&
      (process.env.REACT_APP_ENVIRONMENT === "test" ||
        !soloProducts.includes(allInfo.common.productID) ||
        (soloProducts.includes(allInfo.common.productID) && !isSoloStructuredData))
    ) {
      setLoaderFlag(false);
      if (isInvalidURL) {
        setTimeout(() => {
          window.history.pushState(null, "", `${window.location.protocol}//${window.location.host}/elevate`);
        }, 1000);
      }
    } else {
      setLoaderFlag(true);
    }
  }, [
    allInfo.peopleInformation,
    allInfo.portalLogin,
    allInfo.skillsProgress,
    allInfo.testProgress,
    allInfo.reachProgress,
    allInfo.sprintLevelProgress,
    isSoloStructuredData,
  ]);

  useEffect(() => {
    if (!!!allInfo.peopleInformation.isLoading && !!!allInfo.tmsCourses.isLoading) {
      if (!!allInfo.peopleInformation.data && !!allInfo.tmsCourses.data) {
        const filteredSprintLevelLic = allInfo.peopleInformation.data.getpeopleInformation.license.filter(
          (prod: any) => {
            return (
              prod.productId === "25"
            );
          }
        );
        if (
          !!!allInfo.currentCourseDetails.isLoading &&
          !!!allInfo.currentCourseDetails.isFailed &&
          !!!allInfo.currentCourseDetails.data
        ) {
          const uuId = allInfo.common.luuId;
          let activeCourse = allInfo.tmsCourses.data.getTMSGetCourse.filter(
            (courseFilter: any) => courseFilter.status === "3" || courseFilter.status === "1"
          );
          let courseId = 0;
          if (activeCourse.length > 0) {
            courseId = activeCourse[0].courseId;
          } else {
            let latestCompleted = allInfo.tmsCourses.data.getTMSGetCourse.filter(
              (courseFilter: any) => courseFilter.status === "5"
            );
            courseId =
              latestCompleted.length > 0
                ? latestCompleted.sort((a: any, b: any) => b.courseId - a.courseId)[0].courseId
                : 0;
          }
          setActiveCourse(activeCourse);
          if (filteredSprintLevelLic && filteredSprintLevelLic.length > 0) {
            dispatch(
              allActions.currentCourseDetailsAction.getStoreActiveCourseInfo(
                allInfo.common.leuId,
                filteredSprintLevelLic[0].licenseId,
                filteredSprintLevelLic[0].productId,
                uuId,
                courseId
              )
            );
          }
        }
      }
      if (!!allInfo.currentCourseDetails.isFailed) {
        setLoaderFlag(false);
        dispatch(allActions.toasterActions.showToastMessage(true, "error", "message_errorDefault"));
      }
    }
  }, [allInfo.peopleInformation, allInfo.currentCourseDetails, allInfo.tmsCourses]);  

  return (
    <React.Fragment>
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />      
      <Loader showLoader={loaderFlag} />
      {true ? (
        <div className="progresspage-container">
          <div className="progresspage-title">
            <h1>{translate("progress_title")}</h1>
          </div>
          <div className="progresspage-body">
            <div className={classes.root}>
              <AppBar position="static" color="default">
                <Tabs
                  value={productTabIndex}
                  className={"tabs-trigger-container h1-tab"}
                  onChange={handleProductChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="Product list tabs"
                >
                  {productsList &&
                    productsList.map((product: any, mainIndex: number) => {
                      return (
                        <Tab
                          key={product.productId}
                          data-product={product.productId}
                          label={product.productName}
                          {...a11yProps_dynamic(mainIndex, "auto")}
                        />
                      );
                    })}
                </Tabs>
              </AppBar>
              { productsList &&
                productsList.map((product: any, listIndex: number) => {
                  if (product.productId === "25") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        {structuredElevateData && structuredElevateData.length > 0 ? (
                          <div className="tab-main-body m0 p0 inside-tab">
                            <div className="reach-skills-body-container">
                              <div className="levels-progress-skills-card-ul">
                                <div>
                                  <AppBar position="static" color="default">
                                    <Tabs
                                      value={elevateTab}
                                      onChange={handleElevateChange}
                                      className={"tabs-trigger-container h2-tab"}
                                      indicatorColor="primary"
                                      textColor="primary"
                                      variant="scrollable"
                                      scrollButtons="auto"
                                      aria-label="sprint levels level tabs"
                                    >
                                      {structuredElevateData &&
                                        structuredElevateData.map((indivSession: any, index: number) => {
                                          return (
                                            <Tab
                                              key={index}
                                              label={indivSession.level}
                                              {...a11yProps_dynamic(index, "25")}
                                            />
                                          );
                                        })}
                                    </Tabs>
                                  </AppBar>
                                  {structuredElevateData &&
                                    structuredElevateData.map((indivSession: any, index: number) => {
                                      return (
                                        <TabPanel
                                          value={elevateTab}
                                          index={index}
                                          key={index * Math.random()}
                                          prodId={"25"}
                                        >
                                          {indivSession.parts &&
                                            indivSession.parts.length > 0 &&
                                            indivSession.parts.map((indivPart: any, index: number) => {
                                              return (
                                                <div key={index} className="parts-block">
                                                  {indivPart && indivPart.sessionsCompleted.length > 0 && (
                                                    <div className="completion-card-cover-elevate">
                                                      <div className="part-title">
                                                        {getPartTitle(indivPart.coursePartTitle)}
                                                      </div>
                                                      <CompletionCard
                                                        type="2"
                                                        title={translate("progress_overall_card_title_session")}
                                                        cardData={indivPart.statistics || {}}
                                                      />
                                                      <CompletionCard
                                                        type="3"
                                                        title={translate("progress_overall_card_title_certificate")}
                                                        cardData={indivPart.level || {}}
                                                        partTitle={indivPart.coursePartTitle}
                                                      />
                                                    </div>
                                                  )}
                                                  {indivPart.sessionsCompleted &&
                                                    indivPart.sessionsCompleted.length > 0 &&
                                                    indivPart.sessionsCompleted.map((session: any, index: number) => {
                                                      return (
                                                        <SubSkillCard
                                                          key={index}
                                                          subSkillData={session}
                                                          showHomeWork={false}
                                                          isSolo={false}
                                                          isElevate={true}
                                                        ></SubSkillCard>
                                                      );
                                                    })}
                                                </div>
                                              );
                                            })}
                                        </TabPanel>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <NoDataFound />
                        )}
                      </TabPanel>
                    );
                  } else if (product.productId === "$0") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        <div className="test-results-all-cards-cover white">
                          <ChartsComponent pageInited={pageInited} />
                        </div>
                      </TabPanel>
                    );
                  } else if (product.productId === "$1") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        <div className="test-results-all-cards-cover">
                          {testResultsList && testResultsList.length > 0 ? (
                            testResultsList.map((result, index: number) => {
                              return <TestResultCard key={index * Math.random()} portalLoginURL={portalLoginURL} result={result} productId={allInfo.common.productID}></TestResultCard>;
                            })
                          ) : (
                            <NoDataFound />
                          )}
                        </div>
                      </TabPanel>
                    );
                  } else {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        <NoDataFound />
                      </TabPanel>
                    );
                  }
                })}
            </div>
          </div>
        </div>
      ) : (
        <ErrorPage status={404} />
      )}
    </React.Fragment>
  );
};

ElevatePage.propTypes = { productsList: PropTypes.array };

export default ElevatePage